import axios from 'axios';

const UnsplashClient = axios.create({
  headers: {
    Authorization: `Client-ID ${process.env.REACT_APP_UNSPLASH_KEY}`,
  },
});

export { UnsplashClient };
